// src/utils/empresaScope.js
// Utilitários para aplicar o escopo de empresa (modoGlobal x empresaAtual)
// Mantém compatibilidade com campos antigos (empresaID, empresaId, empresaNome, empresa, etc.)

function normStr(v) {
  return (v ?? "").toString().trim();
}

function normLower(v) {
  return normStr(v).toLowerCase();
}

export function normalizarEmpresaRef(raw) {
  if (!raw) return null;
  if (typeof raw === "string") {
    const nome = normStr(raw);
    return nome ? { id: null, nome } : null;
  }
  if (typeof raw === "object") {
    const id = raw.id ?? raw.empresaId ?? raw.empresaID ?? null;
    const nome = raw.nome ?? raw.empresaNome ?? raw.empresa ?? raw.name ?? "";
    const nomeOk = normStr(nome);
    return id || nomeOk ? { id: id ? String(id) : null, nome: nomeOk } : null;
  }
  return null;
}

export function filtrarPorEmpresa(lista, empresaAtual, modoGlobal) {
  if (modoGlobal) return Array.isArray(lista) ? lista : [];
  const emp = normalizarEmpresaRef(empresaAtual);
  if (!emp) return Array.isArray(lista) ? lista : [];

  const alvoId = emp.id ? String(emp.id) : null;
  const alvoNome = normLower(emp.nome);

  const arr = Array.isArray(lista) ? lista : [];
  return arr.filter((item) => {
    if (!item) return false;

    // Caso "empresas" (docs do Firestore) ou itens com id/nome
    const directId = item.id ?? item.empresaId ?? item.empresaID ?? null;
    const directNome = item.nome ?? item.empresaNome ?? null;

    if (alvoId && directId && String(directId) === alvoId) return true;
    if (alvoNome && directNome && normLower(directNome) === alvoNome) return true;

    // Campos comuns nas coleções do Mamute
    const eid =
      item.empresaID ??
      item.empresaId ??
      item.empresa_id ??
      item.empresaBaseId ??
      item.empresaBaseID ??
      null;

    if (alvoId && eid && String(eid) === alvoId) return true;

    const en =
      item.empresaNome ??
      item.empresa ??
      item.empresaBase ??
      item.nomeEmpresa ??
      null;

    if (alvoNome && en && normLower(en) === alvoNome) return true;

    // Caso item.empresa seja objeto
    if (typeof item.empresa === "object" && item.empresa) {
      const oId = item.empresa.id ?? item.empresa.empresaId ?? item.empresa.empresaID ?? null;
      const oNome = item.empresa.nome ?? item.empresa.empresaNome ?? item.empresa.empresa ?? null;
      if (alvoId && oId && String(oId) === alvoId) return true;
      if (alvoNome && oNome && normLower(oNome) === alvoNome) return true;
    }

    return false;
  });
}

export function mapEmpresasPermitidasNomes(empresasPermitidas) {
  const arr = Array.isArray(empresasPermitidas) ? empresasPermitidas : [];
  return arr
    .map((e) => (typeof e === "string" ? normStr(e) : normStr(e?.nome)))
    .filter(Boolean);
}
